module.exports = __webpack_public_path__ + "static/media/LeavingThisMonth.851ee7e2.png";